// Report an issue (CODE-DELTAS WP-SHELL 4, 7): the report dialog belongs to the SDK's own button, mounted hidden once (StatusBar mounts
// `ReportIssueHost`); the account menu's "Report an issue" closes the menu first and then clicks it, so the screenshot it takes shows the
// screen, not the menu. Help & About and Keyboard shortcuts are the account menu's own rows (the status bar's Help menu is gone). WP-SHELL.
import { lazy, Suspense } from "react";

// The report dialog (it takes a screenshot of the screen) loads after the first paint, never with it.
const ReportIssue = lazy(() => import("@ncp/assistant-sdk").then((m) => ({ default: m.ReportIssue })));

/** Opens the SDK's report dialog (its button is mounted hidden by ReportIssueHost). */
export function openReportIssue(): void {
  window.setTimeout(() => document.querySelector<HTMLButtonElement>("[data-econic-report-issue] button")?.click(), 120);
}

/** The SDK's report button, mounted once and hidden; `openReportIssue()` clicks it. */
export function ReportIssueHost() {
  return <div hidden data-econic-report-issue=""><Suspense fallback={null}><ReportIssue app="assistant" /></Suspense></div>;
}
